<sgt-select
  [settings]="settings"
  [options]="options"
  [ngModel]="value"
  (selectedValueChanged)="onSelectedValueChanged($event)"
>
  <ng-template #customOptionTemplate let-option>
    <sgt-escala-rentabilidade [id]="escalaIdByRecordId[option.id]"></sgt-escala-rentabilidade>
    <span class="ml-2">{{ option.label }}</span>
  </ng-template>
</sgt-select>
